import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, MachineRaroBrand, Notice, Serif } from '@raro/ui';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import ocean from '../assets/ocean.jpg';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Conectar a Machine ao Claude (OAuth): o Claude manda a pessoa para cá, ela já entrou na Machine, vê quem está pedindo e
 * para onde o acesso volta, e diz sim (com a declaração de treinamento) ou não. A resposta devolve a pessoa ao aplicativo.
 */
export function ConectarPage() {
  const [params] = useSearchParams();
  const pedido = params.get('pedido') ?? '';
  const { me } = useAuth();
  const info = useQuery({ queryKey: ['oauth-pedido', pedido], queryFn: () => api.get<{ aplicativo: string; destino: string; pode: boolean }>(`/oauth/pedido?pedido=${encodeURIComponent(pedido)}`), enabled: Boolean(pedido), retry: false });
  const [trainingOff, setTrainingOff] = useState(false);
  const decide = useMutation({
    mutationFn: (permitir: boolean) => api.post<{ redirect: string }>('/oauth/consentimento', { pedido, permitir, trainingOff: permitir ? trainingOff : undefined }),
    onSuccess: (r) => window.location.assign(r.redirect),
  });
  const p = info.data;
  return (
    <div className="rr-auth">
      <section className="rr-auth__hero"><img className="rr-auth__hero-img" src={ocean} alt="" aria-hidden="true" /><MachineRaroBrand size="xl" /><p className="rr-heading">tornar visível<br />o que é visível.</p></section>
      <section className="rr-auth__panel">
        <div className="rr-auth__form rr-form">
          <div className="rr-stack rr-stack--2">
            <span className="rr-label">conectar ao Claude</span>
            <h1 className="rr-title">A Machine no <Serif italic>seu Claude</Serif>.</h1>
          </div>
          {!pedido && <Notice tone="error">Falta o pedido de conexão. Comece de novo pelo Claude.</Notice>}
          {info.isError && <Notice tone="error">{(info.error as Error).message}</Notice>}
          {p && !p.pode && <Notice tone="error">A Machine no Claude é só para a equipe Raro. Você entrou como {me?.email}.</Notice>}
          {p?.pode && (
            <div className="rr-stack rr-stack--3">
              <p style={{ margin: 0 }}><b>{p.aplicativo}</b> quer consultar a Machine em seu nome ({me?.email}), com o mesmo acesso que você tem aqui. O acesso volta para <b>{p.destino}</b>.</p>
              <p className="rr-faint" style={{ margin: 0, fontSize: 'var(--rr-text-sm)' }}>Toda consulta fica na Atividade. Você desliga a conexão quando quiser, no seu perfil, em Conexões.</p>
              <label className="rr-row" style={{ gap: 'var(--rr-space-2)', alignItems: 'flex-start', fontSize: 'var(--rr-text-sm)' }}>
                <input type="checkbox" checked={trainingOff} onChange={(e) => setTrainingOff(e.target.checked)} style={{ marginTop: 3 }} />
                <span>O meu Claude não treina com o que a Machine devolve: uso o plano Team ou desmarquei a opção de ajudar a melhorar os modelos (Ajustes › Privacidade). São dados de cliente e dados pessoais.</span>
              </label>
              {decide.isError && <Notice tone="error">{(decide.error as Error).message}</Notice>}
              <div className="rr-form__actions rr-row" style={{ gap: 'var(--rr-space-3)' }}>
                <Button variant="primary" disabled={!trainingOff || decide.isPending} onClick={() => decide.mutate(true)}>permitir</Button>
                <Button variant="ghost" disabled={decide.isPending} onClick={() => decide.mutate(false)}>recusar</Button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
